import { createSlice } from "@reduxjs/toolkit";


const initialState = {
  token: null,
  user: null,
  onBoardingStartContext:"",
  currentTutorialStep:"",
  userMail:""
};

export const userSlice = createSlice({
  name: "userSlice",
  initialState,
  reducers: {
    storeUser: (state, action) => {
      if (!action.payload) return;
      state.user = action.payload.user;
      state.token = action.payload.token;
    },
    updateUser: (state, action) => {
      if (!action.payload) return;

      state.user = action.payload;
    },
    setEditable: (state, action) => {
      state.editable = action.payload;
    },
    setOnBoardingStartContext:(state,action)=>{
      state.onBoardingStartContext=action.payload;
    },
    setUserEmail:(state,action)=>{
     state.userMail=action.payload;
    },
    resetOnBoardingStartContext:(state)=>{
      state.onBoardingStartContext="";
    },
    setCurrentTutorialStep:(state,action)=>{
     state.currentTutorialStep=action.payload; 
    }
  },
});

export const { storeUser, updateUser, setEditable,setUserEmail,setOnBoardingStartContext,resetOnBoardingStartContext,setCurrentTutorialStep} = userSlice.actions;

export default userSlice.reducer;
